<template>
  <a-card :bordered="false">
    <div>
      <a-form :form="form">
        <a-form-item label="用户ID" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="false">
          <a-input-number v-decorator="['user_id', {rules: [{required: true, message: '请输入'}]}]" style="width: 100%" />
        </a-form-item>
        <a-form-item label="关联用户" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <span>{{ userNickname }}</span>
        </a-form-item>
        <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', {rules: [{required: true, message: '请输入姓名'}]}]" />
        </a-form-item>
        <a-form-item label="公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['company']" />
        </a-form-item>
        <a-form-item label="职位" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['position']" />
        </a-form-item>
        <a-form-item label="部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['department']" />
        </a-form-item>
        <a-form-item label="手机" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['phone']" />
        </a-form-item>
        <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['email']" />
        </a-form-item>
        <a-form-item label="微信" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['wechat']" />
        </a-form-item>
        <a-form-item label="头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-upload
            name="file"
            accept="image/png, image/jpeg, image/jpg"
            :action="ossActionUrl"
            list-type="picture-card"
            :data="ossUploadParams"
            :file-list="fileList"
            :before-upload="beforeUpload"
            @change="handleAvatarChange"
            @preview="handlePreview"
          >
            <div v-if="fileList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传头像</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['address']" />
        </a-form-item>
        <a-form-item label="经纬度" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-row :gutter="8">
            <a-col :span="12">
              <a-input
                v-decorator="['latitude']"
                placeholder="纬度"
              />
            </a-col>
            <a-col :span="12">
              <a-input
                v-decorator="['longitude']"
                placeholder="经度"
              />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col span="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>      </a-form>
    </div>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { card_detail, card_update } from '@/api/business_card'
import { oss_token_list } from '@/api/oss_token'

export default {
  name: 'CardEdit',
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      userNickname: '',
      ossActionUrl: '',
      ossUploadParams: {
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        signature: ''
      },
      fileList: [],
      avatarUrl: ''
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.id = parseInt(id)
      // 先初始化 OSS，再加载编辑信息
      this.initOssUpload()
      this.loadEditInfo()
    }
  },
  methods: {
    initOssUpload () {
      oss_token_list().then(({ data }) => {
        this.ossUploadParams.OSSAccessKeyId = data.accessid
        this.ossUploadParams.policy = data.policy
        this.ossUploadParams.signature = data.signature
        this.ossActionUrl = 'https://static2.jnzbtz.com'
      })
    },
    beforeUpload (file) {
      const allows = ['image/jpeg', 'image/png', 'image/jpg']
      if (allows.indexOf(file.type) === -1) {
        this.$message.warning('只支持 jpg/png 格式的图片')
        return false
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message.warning('图片大小不能超过 5MB')
        return false
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      this.ossUploadParams.key = file.uid + '_' + file.lastModified + '.' + suffix
      return true
    },
    handleAvatarChange ({ file, fileList }) {
      // 上传新头像时，替换旧头像
      if (file.status === 'uploading') {
        this.fileList = fileList
      }
      if (file.status === 'done') {
        const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
        this.avatarUrl = this.ossActionUrl + '/' + file.uid + '_' + file.lastModified + '.' + suffix
        // 只保留新上传的头像
        this.fileList = [{
          uid: file.uid,
          name: file.name,
          status: 'done',
          url: this.avatarUrl
        }]
      }
      if (file.status === 'removed') {
        this.fileList = []
        this.avatarUrl = ''
      }
    },
    handlePreview (file) {
      window.open(file.url || file.thumbUrl)
    },
    handleGoBack () {
      this.$router.go(-1)
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (!err) {
          // 如果有新上传的头像，使用新的
          if (this.avatarUrl) {
            values.avatar = this.avatarUrl
          }
          card_update(values, this.id).then(() => {
            this.$notification.success({
              message: '修改成功',
              description: '名片信息已更新'
            })
            this.handleGoBack()
          })
        }
      })
    },
    loadEditInfo () {
      const { form } = this
      card_detail(this.id).then(res => {
        const data = res.data
        if (data) {
          this.id = data.id
          this.userNickname = data.user_nickname || ''
          const formData = pick(data, [
            'user_id', 'name', 'company', 'position', 'department',
            'phone', 'email', 'wechat', 'address', 'latitude', 'longitude'
          ])
          form.setFieldsValue(formData)
          // 初始化头像列表 - 使用 setTimeout 确保 DOM 更新后再设置
          if (data.avatar) {
            this.$nextTick(() => {
              this.fileList = [{
                uid: '-1',
                name: 'avatar.png',
                status: 'done',
                url: data.avatar
              }]
            })
          }
        }
      })
    }
  }
}
</script>
